import { useQuery } from '@tanstack/react-query';
import { procurementService } from '../../services/procurement.service';
import { queryKeys } from '../../lib/query-keys';

export function usePurchaseOrders(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.purchaseOrders.all(orgId ?? ''),
    queryFn: () => procurementService.getPurchaseOrders(1, 100, { organization_id: orgId }),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}
